import { css } from 'lit';
export default css `
  p {
    margin: 0;
    padding: 0;
    font-size: 16px;
    line-height: 24px;
    font-weight: 600;
    letter-spacing: -0.2px;
  }
`;
//# sourceMappingURL=styles.js.map